import { AxiosInstance } from 'axios';

//because the lib needs to reference axios instances and mobile and web implement their own axios instances,
//we need to explicitly set them where theyre defined:
//on web: src\asyncHelpers\index.ts

let libApiInstance: AxiosInstance;
let libAuthInstance: AxiosInstance;

export function setApiAxiosInstance(newInstance: AxiosInstance) {
    libApiInstance = newInstance;
}

export function setAuthAxiosInstance(newInstance: AxiosInstance) {
    libAuthInstance = newInstance;
}

export { libApiInstance, libAuthInstance };
